<template>
  <div :class="['newsletterHome', { 'newsletterHome--white': white }]">
    <div class="container">
      <div class="newsletterHome__wrapper">
        <div class="newsletterHome__text">
          <newsletter-text big-title="Nie przegap okazji!" desc="Zapisz się do newslettera." />
        </div>
        <div class="newsletterHome__images">
          <img :src="imageLeft" alt="" width="210" height="106" class="newsletterHome__imageLeft" />
          <img
            :src="imageRight"
            alt=""
            width="300"
            height="186"
            class="newsletterHome__imageRight"
          />
          <img
            :src="imageMobile"
            alt=""
            width="292"
            height="268"
            class="newsletterHome__imageMobile"
          />
        </div>
        <div class="newsletterHome__input">
          <newsletter-form />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormInputWithButton from '~/components/Form/FormInputWithButton';
import NewsletterText from '~/components/Newsletter/NewsletterText';
import NewsletterForm from '~/components/Newsletter/NewsletterForm';

export default {
  name: 'NewsletterHome',
  components: {
    NewsletterForm,
    FormInputWithButton,
    NewsletterText,
  },
  props: {
    name: {
      type: String,
      default: 'newsletter',
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageLeft: '/images/newsletterHomeOne.svg',
      imageRight: '/images/newsletterHomeTwo.svg',
      imageMobile: '/images/newsletterHomeMobile.svg',
    };
  },
};
</script>
<style lang="scss">
.newsletterHome {
  $root: &;
  transform: translateY(50%);

  @include rwd('ultra') {
    //margin-top: 7rem;
    transform: translateY(35%);
  }

  @include rwd('tablet') {
    margin-top: 7rem;
    transform: translateY(0);
  }

  & .container {
    @include rwd('tablet') {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__wrapper {
    display: flex;
    margin: 0 auto;
    padding: 1rem 6rem 0;
    align-items: center;
    justify-content: space-between;
    border: 14px solid $cWhite;
    background-color: $cBg;
    position: relative;

    @include rwd('large-laptop') {
      padding: 0 4rem;
    }

    @include rwd('laptop') {
      padding: 0 2rem;
    }

    @include rwd('tablet') {
      border: 0;
      flex-direction: column;
      height: auto;
      padding: 2rem;
    }

    @include rwd('phone') {
      padding: 2rem 0.5rem 3rem 0.5rem;
    }
  }

  &__input {
    width: 47.2rem;

    & button {
      padding: 0 5rem;

      @include rwd('laptop') {
        padding: 0 2.2rem;
      }
    }

    & label {
      display: flex;
      justify-content: space-between;
    }

    & input:not(.formCheckboxSimple__input) {
      @include rwd('large-tablet') {
        padding: 1.6rem 1rem;
        width: calc(100% - 10rem);
      }
    }

    @include rwd('tablet') {
      max-width: 100%;
      position: absolute;
      width: calc(100% - 40px);
      bottom: 24px;
    }

    @include rwd('phone') {
      width: calc(100% - 20px);
    }
  }

  &__text {
    z-index: 2;
  }

  &__images {
    position: relative;
    margin-left: 3rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;

    @include rwd('large-laptop') {
      margin-left: 4rem;
    }

    @include rwd('large-tablet') {
      margin-left: 0;
      align-items: baseline;
    }

    @include rwd('tablet') {
      margin-top: 1rem;
    }
  }

  &__imageLeft {
    max-width: 21rem;
    position: absolute;
    left: -11rem;
    top: 0.5rem;
    z-index: 1;

    @include rwd('large-laptop') {
      left: -9rem;
    }

    @include rwd('laptop') {
      max-width: 70%;
      left: -5rem;
      top: -1rem;
      z-index: 12;
    }

    @include rwd('large-tablet') {
      position: static;
      max-width: 80%;
      top: auto;
      left: auto;
      margin-bottom: -3.5rem;
    }

    @include rwd('tablet') {
      display: none;
    }
  }

  &__imageRight {
    max-width: 30rem;
    z-index: 10;

    @include rwd('laptop') {
      max-width: 26rem;
    }

    @include rwd('large-tablet') {
      max-width: 22rem;
    }

    @include rwd('tablet') {
      display: none;
    }
  }

  &__imageMobile {
    display: none;
    @include rwd('tablet') {
      display: block;
      max-width: 27.6rem;
    }

    @include rwd('phone') {
      max-width: 95%;
    }
  }

  &--white {
    position: relative;
    margin-top: -2rem;

    @include rwd('tablet') {
      margin-top: 0;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 50%;
      background: white;

      @include rwd('ultra') {
        height: 35%;
      }

      @include rwd('tablet') {
        height: 0;
      }
    }
  }
}
</style>
